enum TseAccountType {
  StoredValue = 'stored-value',
  MealPlan = 'meal-plan',
  CashEquivalency = 'cash-equivalency',
}

export { TseAccountType };
